import { gql } from "lib/apolloClient";
import { similarityFragment } from "modules/CommonFragments";

export const attachmentFragment = {
  attachment: gql`
    fragment attachmentItem on Attachment {
      id
      name
      type
      mimeType
      url
      signedUrl
      thumbUrl
      title
      metadata
      streamUrl
      parentType
      isRead
      similarityReport {
        ...similarityItem
      }
      childAttachments {
        id
        type
      }
      createdBy {
        id
        type
      }
      lockingState {
        state
        scheduledAt
      }
      questionAttachment {
        ... on QuestionSubmission {
          id
          questionScore
          score {
            id
            value
          }
        }
        ... on Question {
          id
          questionScore
        }
      }
    }
    ${similarityFragment.similarityItem}
  `,
};

export const attachmentGroupsFragment = {
  attachmentGroup: gql`
    fragment attachmentGroupItem on AttachmentGroup {
      id
      metadata
      attachments {
        ...attachmentItem
      }
      studentTemplate {
        id
      }
    }
    ${attachmentFragment.attachment}
  `,
};
